<div class="pra">
  <app-container>
    <div class="pra-wrapper">
      @for (item of praList; track item) {
        <div class="item">
          <app-project-status
            [status]="item.regActProject?.[0]?.status"
          ></app-project-status>

          <div class="title">{{ item.regActProject?.[0]?.title }}</div>
          <div class="desc">
            {{ item.adoptionPurpose }}
          </div>

          <div class="info-wrapper">
            <div class="info">
              Регуляторний орган: {{ item.authorizedUnit }}
            </div>
            <div class="info">Дата прийняття: {{ item.startDate }}</div>
          </div>

          <div class="footer-info">
            <div class="counts">
              <img src="../../../../../../assets/img/icons/eye.svg" alt="" />
              <div class="count">{{ item.viewCount }}</div>
            </div>
            <div class="link">
              <img
                [routerLink]="['/acts', item.regPlanItemId]"
                src="../../../../../../assets/img/icons/arrow-right.svg"
                alt="arrow"
              />
            </div>
          </div>
        </div>
      }
    </div>
  </app-container>
</div>
